import { customAxios } from './customAxios'
export function sendNotificationStatus(idRichiestaSupporto, body) {
  const config = {
    headers: {
      AuthToken: JSON.parse(localStorage.getItem('token')),
    },
  }

  return customAxios.post(
    `${process.env.REACT_APP_BACKEND_HOST}/${process.env.REACT_APP_PATH_NEW_PREFIX}/richiesta/supporto/notification/status/${idRichiestaSupporto}`,
    body,
    config,
  )
}
